export function apiUrl(): string {
  return import.meta.env.VITE_API_BASE_URL ?? '';
}

export function disableRbac(): boolean {
  const flag = import.meta.env.VITE_DISABLE_RBAC ?? '';
  return ['1', 'true'].includes(flag);
}

export function entraAuthority(): string {
  return import.meta.env.VITE_ENTRA_AUTHORITY ?? '';
}

export function entraClientId(): string {
  return import.meta.env.VITE_ENTRA_CLIENT_ID ?? '';
}

export function entraRedirectUri(): string {
  return import.meta.env.VITE_ENTRA_REDIRECT_URI ?? '';
}

export function entraScopes(): string[] {
  const scopes = import.meta.env.VITE_ENTRA_SCOPES ?? '';
  return scopes.length ? scopes.split(',') : [];
}

export function featureEnableEquipmentWatchlist() {
  const flag = import.meta.env.VITE_FEATURE_ENABLE_EQUIPMENT_WATCHLIST ?? '';

  return ['1', 'true'].includes(flag);
}

export function mode(): string {
  return import.meta.env.MODE;
}
